module.exports = __webpack_public_path__ + "media/images/lp_chintai/sec01_bg_01-06cfd002e2297fd36e52ef9ca6bc14c9.png";